import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import "../user_styles/languageSwitcher.css";

const OPTIONS = [
  { code: "ko", label: "한국어", flag: "/flags/kr.svg" },
  { code: "zh", label: "中文", flag: "/flags/cn.svg" },
];

export default function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();
  return (
    <div className="language-switcher">
      {OPTIONS.map((opt) => (
        <button
          key={opt.code}
          type="button"
          className={`language-switcher-btn${lang === opt.code ? " active" : ""}`}
          aria-label={opt.label}
          aria-pressed={lang === opt.code}
          onClick={() => setLang(opt.code)}
        >
          <img className="language-switcher-flag" src={opt.flag} alt={opt.label} />
        </button>
      ))}
    </div>
  );
}
